<template>
    <header id="header" class="section header">

        <div class="header-image">
            <div class="space-home"></div>
            <div id="bm"></div>
        </div>

        <div class="navigation-wrap">
            <nav class="navigation">
                <div class="hamburger"><div class="hamburger-line"></div><div class="hamburger-line"></div><div class="hamburger-line"></div></div>
                <ul>
                    <router-link tag="li" to="/"><a>Home</a></router-link>
                    <router-link tag="li" to="/research"><a>Research</a></router-link>
                    <router-link tag="li" to="/events"><a>Events & Activities</a></router-link>
                    <router-link tag="li" to="/editions"><a>Editions</a></router-link>
                    <router-link tag="li" to="/database"><a>Database</a></router-link>
                    <router-link tag="li" to="/stories"><a>Stories</a></router-link>
                    <router-link tag="li" to="/links"><a>Links</a></router-link>
                    <router-link tag="li" to="/contact"><a>Contact</a></router-link>
                    <router-link tag="li" to="/imprint"><a>Imprint</a></router-link>
                </ul>
                <div class="news-button">
                    <span>News</span>
                    <div class="hamburger-line"></div><div class="hamburger-line"></div><div class="hamburger-line"></div>
                </div>
            </nav>
        </div>

    </header>
</template>

<script>
    import bodymovinjs from 'bodymovin'
    export default {
        name: "Header",
        props: ['site'],
        mounted: function () {
            bodymovinjs.loadAnimation({
                container: document.getElementById('bm'),
                renderer: 'svg',
                loop: false,
                autoplay: true,
                path: 'Animation_V2.6.json'
            })
        }
    }
</script>

<style scoped lang="css">
    #header {
        background-color: white;
        box-sizing:border-box;
        text-align:center;
    }

    .header-image {
        background-color:rgb(158,28,28);
        background-image: url(../assets/pasticcio-web-desktop-final-180424.png);
        background-repeat:no-repeat;
        background-size: 1280px auto;
        background-position:center;
        width:100%;
        height:305px;
        vertical-align: middle;
    }
    .header-image img {
        margin-top:80px;
    }

    /* Navigation */
    .navigation-wrap {
        width:100%;
        min-height:32px;
        margin:0;
        background-color:rgb(239,236,236);
        position:relative;
    }
    .navigation {
        width:1020px;
        min-height:32px;
        margin:0 auto;
        line-height:40px;
        font-family: 'Lato', sans-serif;
        font-size:16px;
        text-align:left;
        position:relative;
        box-sizing:border-box;
    }
    .navigation li {
        display:inline-block;
        margin:0 4px;
    }
    .navigation li:first-child {
        margin-left:0;
    }
    .navigation li:last-child {
        margin-right:0;
    }
    .navigation li a{
        color:#930303;
        display:inline-block;
        height:40px;
        padding:0 20px;
    }

    .navigation li.router-link-active a,
    .navigation li a:hover {
        color:#fff;
        background-color:#930303;
        text-decoration:none;
    }

    /* HOME Nav only when exact active*/
    .navigation li:first-child.router-link-active a {
      color:#930303;
      background-color: inherit;
    }
    .navigation li:first-child.router-link-exact-active a,
    .navigation li:first-child a:hover {
        color:#fff;
        background-color:#930303;
        text-decoration:none;
    }

    .hamburger {
        width:28px;
        height:24px;
        cursor: pointer;
        display:none;
        position:relative;
        margin:0 4vw;
    }
    .hamburger-line {
        height:3px;
        width:28px;
        margin-bottom:5px;
        background-color: white;
    }
    .hamburger.active {
        margin-top:-2px;
    }
    .hamburger.active .hamburger-line:first-child {
        transform: rotate(45deg);
        transform-origin:0 100%;
        width:30px;
        margin-top:0;
        margin-left:0;
    }
    .hamburger.active .hamburger-line:nth-child(2) {
        display:none;
    }
    .hamburger.active .hamburger-line:last-child {
        transform: rotate(-45deg);
        transform-origin: 0 100%;
        width:30px;
        margin-top:18px;
        margin-left:1px;
    }

    .space-home {
        height:80px;
    }

    #bm {
        width:330px;
        margin:0 auto;
    }

    /* ---------------------------------------- News */

    .news-button {
        display:none;
    }

    @media only screen and (min-width: 1px) and (max-width: 1279px) {

        .navigation {
            width:90vw;
        }

        .navigation li a{
            height:40px;
            padding:0 1.6vw;
        }
    }

    @media only screen and (min-width: 1px) and (max-width: 1059px) {

        .navigation {
            width:100%;
        }
    }

    @media only screen and (min-width: 1px) and (max-width: 799px) {
        .navigation-wrap {
            background-color:#930303;
        }
        .navigation{
            padding-top:6px;
        }
        .hamburger {
            display:block;
        }

        .navigation ul {
            display:none;
            position:absolute;
            top:32px;
            background-color:rgba(255,255,255,0.95);
            width:100%;
            box-sizing:border-box;

            -webkit-box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
            box-shadow: 0 1px 1px 0 rgba(0,0,0,0.2);
        }

        .navigation li {
            display:block;
            width:100%;
            box-sizing:border-box;
            margin:0;
        }
        .navigation li a {
            padding:0 4vw;
            display:block;
            box-sizing:border-box;
            margin-top:1px;
        }

        /* ---------------------------------------- News */

        .news-button {
            color:white;
            cursor:pointer;
            display:block;
            position:absolute;
            top:-4px;
            right:4vh;
        }
        .news-button.active {
            margin-top:8px;
        }
        .news-button.active span {
            display:none;
        }
        .news-button.active .hamburger-line:nth-child(2) {
            transform: rotate(45deg);
            transform-origin:0 100%;
            width:30px;
            margin-top:0;
            margin-left:0;
        }
        .news-button.active .hamburger-line:nth-child(3) {
            display:none;
        }
        .news-button.active .hamburger-line:nth-child(4) {
            transform: rotate(-45deg);
            transform-origin: 0 100%;
            width:30px;
            margin-top:18px;
            margin-left:1px;
        }
    }
</style>
